import { getAuthData } from "@common/helpers/auth";
import Config from "@skin_config";
import { depositMethods } from "../constants/depositMethods";
import { TerminalDepositModesEnum } from '../constants/enums/terminalDepositModes';

export const getAvailableDepositMethods = (user, terminalBalance, terminalDepositMode) => {
  const authData = getAuthData();
  const { enableOnlinePayment, betshopid: betshopId, tid } = authData || {};
  const methodList = Config.depositMethods
    .filter((method) => depositMethods[method.type]
      && ((method.enabled || +enableOnlinePayment) && !method.disabledBetshopIds?.includes?.(+betshopId) && (!method.enabledTerminalIds?.length || method.enabledTerminalIds?.includes(+tid)))
      && (!method.disableBalanceMixing
        || terminalBalance === 0
        || [TerminalDepositModesEnum.Ticket, TerminalDepositModesEnum.Octo].includes(terminalDepositMode))) // maybe there will be a need to move this checks to small functions
    .map((method) => ({ ...depositMethods[method.type], ...method }));

  return !user.loggedIn ? methodList.filter((method) => !method.needsLogin) : methodList;
};
